import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export type TabId =
  | 'quote'
  | 'delivery'
  | 'invoice'
  | 'purchase'
  | 'procurement'
  | 'subcontract'
  | 'edit';

interface Tab {
  id: TabId;
  label: string;
}

const TABS: Tab[] = [
  { id: 'edit', label: '案件詳細' },
  { id: 'quote', label: '見積書管理' },
  { id: 'delivery', label: '納品書管理' },
  { id: 'invoice', label: '請求書管理' },
  { id: 'purchase', label: '注文書管理' },
  { id: 'procurement', label: '仕入れ管理' },
  { id: 'subcontract', label: '外注管理' },
];

/** タブID → 見出しラベル（カード見出し等で利用）。 */
export const TAB_LABELS = Object.fromEntries(TABS.map((t) => [t.id, t.label])) as Record<TabId, string>;

interface Props {
  activeTab: TabId;
  onTabChange: (tab: TabId) => void;
}

/** 案件詳細の上段に並ぶ管理項目タブ群（カード外に配置する）。 */
export function OrderDetailTabs({ activeTab, onTabChange }: Props) {
  return (
    <nav className="flex gap-6 -mb-px" aria-label="管理項目タブ">
      {TABS.map((tab) => (
        <button
          key={tab.id}
          type="button"
          onClick={() => onTabChange(tab.id)}
          className={[
            'whitespace-nowrap border-b-2 px-1 py-3 text-sm font-medium transition-colors',
            activeTab === tab.id
              ? 'border-blue-600 text-blue-600'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
          ].join(' ')}
        >
          {tab.label}
        </button>
      ))}
    </nav>
  );
}

export function useOrderTabs() {
  const [searchParams] = useSearchParams();
  // URLクエリ ?tab=quote 等で初期タブを指定可能（見積保存後の遷移などで利用）
  const requested = searchParams.get('tab');
  const initialTab: TabId =
    requested && TABS.some((t) => t.id === requested) ? (requested as TabId) : 'edit';
  const [activeTab, setActiveTab] = useState<TabId>(initialTab);
  return { activeTab, setActiveTab };
}
